import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  rgs: null,
};

const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setRgs: (state, { payload }) => {
      state.rgs = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: generalReducer } = generalSlice;
export const { setRgs } = generalSlice.actions;
